import axios from 'axios';
import { COMMENT_BASE_PATH, COMMENT_APP_ID } from '@src/public/constants';
import { getToken } from '@src/public/utils/app';

// 获取用户token
const token = getToken();

// 评论axios实例
export const request = axios.create();

// 评论axios实例的基础路径
request.defaults.baseURL = COMMENT_BASE_PATH;

// 评论axios实例的自定义header
const commentHeaders = {
    Authorization: `Bearer ${token}`,
    commentAppId: COMMENT_APP_ID,
};

// 评论axios实例的请求拦截器
request.interceptors.request.use(
    config => ({ ...config, headers: { ...config.headers, ...commentHeaders } }),
    err => Promise.reject(err),
);

/**
 * 评论列表
 * @param {string} subjectId 主体id
 * @param {number} page 页码，从1开始
 * @param {number} pageSize 每页条数
 * @param {boolean} queryNextRankComment 是否附带子级评论
 * @param {string} rootId 根评论id
 * @param {string} pId 父评论id
 * @param {object} sort 排序配置
 */
export const getCommentList = ({
    subjectId,
    page,
    pageSize = 10,
    queryNextRankComment = true,
    rootId = '0',
    pId = '',
    sort = {
        key: 'createTime',
        type: 'desc',
    },
}) => {
    return request.post('/queryCommentForPage', {
        body: {
            pagination: {
                current: page,
                pageSize,
            },
            query: {
                subjectId,
                rootId,
                queryNextRankComment,
                pId,
                appId: COMMENT_APP_ID,
            },
            sort,
        },
    });
};

/**
 * 给评论点赞
 * @param {string} commentId 评论id
 * @param {string} opType INSERT/DEL 点赞/取消点赞
 * @param {string} subjectId 主体id
 */
export const postLikeComment = ({ commentId, opType, subjectId }) => {
    return request.post('/likeComment', {
        body: {
            commentId,
            appId: COMMENT_APP_ID,
            subjectId,
        },
        opType,
    });
};

/**
 * 删除评论
 * @param {string} commentId 评论id
 * @param {string} subjectId 主体id
 */
export const postDeleteComment = ({ commentId, subjectId }) => {
    return request.post('/delComment', {
        body: {
            commentId,
            subjectId,
            appId: COMMENT_APP_ID,
        },
    });
};

/**
 * 插入评论
 * @param {string} subjectId 主体id
 * @param {string} comment 评论内容
 * @param {string} rootId 根id
 * @param {string} pId 父id
 */
export const postInsertComment = ({ subjectId, comment, rootId, pId }) => {
    return request.post('/insertComment', {
        body: {
            subjectId,
            comment,
            rootId,
            pId,
            appId: COMMENT_APP_ID,
        },
    });
};

/**
 * 获取单条评论数据
 * @param {string} commentId 评论id
 * @param {string} subjectId 主体id
 */
export const getCommentById = async ({ commentId, subjectId }) => {
    return request.get('/queryCommentDetail', {
        params: {
            id: commentId,
            subjectId,
            appId: COMMENT_APP_ID,
        },
    });
};
